import ResetPasswordFormRedirect from './ResetPasswordFormRedirect';

export default ResetPasswordFormRedirect;
